module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAPCAYAAADphp8SAAAApklEQVQ4jc3SPQrCQBCG4XfFE1nrvexECESFgBJQchBPYGqPEHIK288iO/gXZhNtfCFki5lnCSRIItE6vlfulCTvyfQo82Y9JNdn+Vho24NYu6FQ4SBW4UFB0n4AYh3izgsUJJUjEKs0zJDjF4h1khSQVP2AWNUEaIAl0Kb+zJ7auNt039d1AeZvgxvgGs+zuPRcDSwApokba+AczzdvcJKABvd/0B035hD5ys8tzwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/menu/home.png
// module id = +B9e
// module chunks = 0